
export default {
  namespaced: true,
  state: {
    selectedServiceAreaId: null,
    selectedServiceId: null,
    // nav items
   navigationList: [],

    mainNavObject: {
      serviceAreaItems: [
      ],
      generalNavItems: [
        { name: "Über die NEW", iconNew: "ueberNew", route: "about", hideInBildungsportal: false},
        { name: "Presse", iconNew: "news", route: "news", hideInBildungsportal: true },
        { name: "NEW Magazin", iconNew: "magazin", route: "magazin", hideInBildungsportal: false },
        {
          name: "Fördermöglichkeiten",
          iconNew: "foerdermoeglichkeiten",
          route: "funds", hideInBildungsportal: false
        },
        {
          name: "Bauprojekte",
          iconNew: "bauprojekte",
          route: "constructions-map",
          hideInBildungsportal: true
        },
        {
          name: "Verbrauchsdaten",
          route: "verbrauchsdaten",
          iconMaterialDesign: "chart-bar",
          hideInBildungsportal: true
        },
        {
          name: "Konzessionsabgaben",
          route: "konzessionsabgaben",
          iconMaterialDesign: "file-document-multiple",
          hideInBildungsportal: true
        },
        /*
        {
          name: 'Kommunalrabatt',
          iconNew: 'kommunalrabatt',
          route: 'kommunalrabatt',
          hideInBildungsportal: true
        },
        */
          {
              name: "Analyse Wärmeplanung",
              route: "waerme-analytics",
              iconMaterialDesign: "chart-bar",
              hideInBildungsportal: true
          },
          {
              name: "Veranstaltungen",
              iconNew: "netzwerk",
              route: "veranstaltungen",
              hideInBildungsportal: true
          }
      ],
    },
  },
  mutations: {
    SET_NAVIGATION_LISTS(state, serviceAreaItems) {
      state.mainNavObject.serviceAreaItems = serviceAreaItems;
    },
    SET_SELECTED_SERVICE_AREA_ID(state, serviceAreaId) {
      state.selectedServiceAreaId = serviceAreaId;
    },
    SET_SELECTED_SERVICE_ID(state, serviceId) {
      state.selectedServiceId = serviceId;
    },
  },
  actions: {
    setSelectedServiceAreaId({ commit }, serviceAreaId) {
      commit("SET_SELECTED_SERVICE_AREA_ID", serviceAreaId);
      commit("SET_SELECTED_SERVICE_ID", null);
    },
    setSelectedServiceId({ commit }, serviceId) {
      commit("SET_SELECTED_SERVICE_ID", serviceId);
    },
  },
  getters: {
    getMainNavObject(state) {
      return state.mainNavObject;
    },

    serviceAreas: (state, getters) => {
      return getters.getMainNavObject.serviceAreaItems.map(serviceAreaItem => {
        if(serviceAreaItem.link || serviceAreaItem.services.length > 0) return serviceAreaItem;

        return {
          ...serviceAreaItem,
          link: `/service-area/${serviceAreaItem.id}`
        }
      });
    },

    subServiceBySubServiceId: (state, getters) => id => {
      const serviceAreaItems = getters.getMainNavObject.serviceAreaItems;
      let foundSubService;
      serviceAreaItems.map(serviceArea =>
          serviceArea.services.map(service =>
              service.subServices.find(subService => {
                if (subService.id === id) {
                  foundSubService = subService;
                }
              })
          )
      );
      return foundSubService || null;
    },

    getServiceById: (state, getters) => {
      const serviceAreas = getters.getMainNavObject.serviceAreaItems;

      return serviceAreas;
    },

    serviceAreaByServiceAreaId: (state, getters) => serviceAreaId => {
      return getters.serviceAreas.find(el => el.id === serviceAreaId);
    },
    getServiceAreaByName: (state) => name => {
      for(const serviceArea of state.mainNavObject.serviceAreaItems) {
        if(serviceArea.title === name) {
          return serviceArea;
        }
      }
    },
    getServiceByName: (state) => name => {
      for(const serviceArea of state.mainNavObject.serviceAreaItems) {
        for(const service of serviceArea.services) {
          if(service.title === name) {
            return service;
          }
        }
      }

      return undefined;
    },
    getSubServiceByName: (state) => name => {
      for(const serviceArea of state.mainNavObject.serviceAreaItems) {
        for(const service of serviceArea.services) {
          for(const subService of service.subServices) {
            if(subService.title === name) {
              return subService;
            }
          }
        }
      }

      return undefined;
    },
    getGeneralNavItems(state, getters, rootState, rootGetters) {

      let generalNavItems = state.mainNavObject.generalNavItems;

      if (
          !rootGetters["user/enableKommunalrabatt"] ||
          rootGetters["user/isNewEmployee"]
      ) {
        generalNavItems = generalNavItems.filter(
            item => item.name !== "Kommunalrabatt"
        );
      }

      if(rootGetters["user/isNewEmployee"] || !rootGetters['user/enableVerbrauchsdaten']) {
        generalNavItems = generalNavItems.filter(
            item => item.name !== "Verbrauchsdaten"
        );
      }

      if(rootGetters["user/isNewEmployee"] || !rootGetters["user/enableTestate"]) {
        generalNavItems = generalNavItems.filter(
            item => item.name !== "Konzessionsabgaben"
        )
      }

      if(rootGetters["user/isNewEmployee"] || !rootGetters["user/enableWaermeplanung"]) {
        generalNavItems = generalNavItems.filter(item => item.name !== "Analyse Wärmeplanung")
      }

      return generalNavItems;
    },

    showNavigationOverlay(state) {
      return state.selectedServiceAreaId !== null
          && state.selectedServiceAreaId !== undefined
          && state.selectedServiceAreaId !== ''
    },
    getServices(state, getters, rootState, rootGetters) {
      if(!state.selectedServiceAreaId) return null;

      if(state.selectedServiceAreaId === 'management-dashboard') {
        const managementServices = [];

        if(rootGetters["user/enableKommunenDashboard"]) {
          managementServices.push({ title: 'Kommunenübersicht', link: '/commune-dashboard' })
        }

        if(rootGetters["user/enableVertragsuebersicht"]) {
          managementServices.push({ title: "Verträge", link: "/vertragsuebersicht" })
        }

        if(rootGetters["user/enableKonzessionssachstaende"]) {
          managementServices.push({ title: "Konzessionsthemen", link: '/konzessionsthemen' })
        }

        if(rootGetters["user/enablePoliticalDashboard"]) {
          managementServices.push({ title: "Politische Akteure", link: "/elections" })
        }

        if(rootGetters["user/enableAnalytics"]) {
          managementServices.push({ title: "Analytics", link: "/analytics" })
        }


        return managementServices;
      }

      const serviceAreaItem = state.mainNavObject.serviceAreaItems.find(s => s.id === state.selectedServiceAreaId)

      if(!serviceAreaItem) return null;

      let services = serviceAreaItem.services;
      services.sort((i1, i2) => i1.id - i2.id);

      const enableMoments = rootGetters["user/enableMoments"];
      const enableEinspeisebeteiligung = rootGetters["user/userEnabledEinspeisebeteiligung"];
      const enableTestate = rootGetters["user/enableTestate"];
      const enableWaermeplanung = rootGetters["user/enableWaermeplanung"];
      const filteredServices = [];

      for (const service of services) {
        if(service.title === 'NEW Erleben' && !enableMoments) continue;
        if(service.title === 'Einspeisebeteiligung' && !enableEinspeisebeteiligung) continue;
        if(service.title === 'Konzessionsabgaben' && !enableTestate) continue;
        if(['Kommunale Wärmeplanung', 'Analyse zur Wärmeplanung'].includes(service.title) && !enableWaermeplanung) continue;
        const serviceWithLink = service;

        if(!serviceWithLink.link && serviceWithLink.subServices.length === 0) {
          serviceWithLink.link = `/service-area/${state.selectedServiceAreaId}/service/${service.id}`;
        }

        filteredServices.push(serviceWithLink);
      }

      return filteredServices;
    },
    getSubServices(state) {
      if(!state.selectedServiceAreaId || !state.selectedServiceAreaId) return null;

      const serviceItem = state.mainNavObject.serviceAreaItems.find(s => s.id === state.selectedServiceAreaId)?.services.find(s => s.id === state.selectedServiceId);

      if(!serviceItem) return null;

      return serviceItem.subServices.map(subService => {
        if (subService.link) return subService;
    return {
            ...subService,
      link: `/service-area/${state.selectedServiceAreaId}/service/${state.selectedServiceId}/sub-service/${subService.id}`,
    }
      });
    },
    getNavTitle(state) {
      if(!state.selectedServiceAreaId && !state.selectedServiceAreaId) return null;

      const selectedServiceArea = state.mainNavObject.serviceAreaItems.find(s => s.id === state.selectedServiceAreaId)

      if(!selectedServiceArea) return null;

      if(!state.selectedServiceId) return selectedServiceArea.title;

      const selectedService = selectedServiceArea.services.find(s => s.id === state.selectedServiceId);
      if(!selectedService) return null;
      return selectedService.title;
    },
    getSelectedServiceAreaId(state) {
      return state.selectedServiceAreaId;
    }
  },
};
